import React, {useState, useEffect} from "react"
import Swal from "sweetalert2"
import Stripe from "./forms/Stripe"
import {URL} from "../config"
// import "./styles_components/Cart.css"


const Cart = () => {

	const [cartItems, setCartItems] = useState([])
	// const [quantity, setQuantity] =useState(false)
	// console.log(cartItems)

	let total = 0

	useEffect(()=>{
		setCartItems(JSON.parse(localStorage.getItem('cartItems')))
	}, [])

	if (cartItems.length){
	let subTotals = cartItems.map(item => parseInt(item.price) * parseInt(item.quantity) * parseInt(item.days))

	total = subTotals.reduce((accumulator, subPerItem) => {
		return accumulator + subPerItem
		})
	}


	const checkout = () => {
		let orders = JSON.parse(localStorage.getItem('cartItems'))

			fetch(`${URL}/transactions`, {
				method: "POST",
				body: JSON.stringify({orders, total}),
				headers: {
					"Content-Type": "application/json",
					"x-auth-token": localStorage.getItem("token")
				}
			})
			.then(res=>res.json())
			.then(data=>{
				Swal.fire({
					'icon': 'success',
					'title': data.message
				})

				localStorage.setItem('cartItems', JSON.stringify([]))
				setCartItems(JSON.parse(localStorage.getItem('cartItems')))
			})
		}


	const deleteHandlerSingle = (itemId) => {
		let cartUpdated = cartItems.filter(item=>itemId!==item._id)

		localStorage.setItem("cartItems", JSON.stringify(cartUpdated))
		setCartItems(JSON.parse(localStorage.getItem('cartItems')))
		window.location.href="/booking"
	}


	const deleteHandlerAll = () => {
		localStorage.setItem("cartItems", JSON.stringify([]))
		setCartItems(JSON.parse(localStorage.getItem('cartItems')))
		window.location.href="/booking"
	}


	return (
		<div className="booking-background">
			<h2 className="py-5">For Booking</h2>
		<div className="container col-sm-9">

			{ cartItems.length ?
					<table className="table">
						<thead>
						<tr>
							<th>Tour</th>
							<th>Price</th>
							<th>Person</th>
							<th>Days</th>
							<th>Subtotal</th>
							<th>Action</th>
						</tr>
						</thead>

						<tbody>
						{ cartItems.map(item => (
								<tr key={item._id}>
								<td>{item.name}</td>
								<td>{item.price}</td>
								<td>{item.quantity}</td>
								<td>{item.days}</td>
								<td>{item.quantity * item.price * item.days}</td>
								<td>
									<button className="btn btn-danger ml-1" onClick={()=>deleteHandlerSingle(item._id)}>Delete</button>
								</td>
								</tr> ))}

							<tr>
								<td></td>
								<td></td>
								<td></td>
								<td>Total</td>
								<td>{total}</td>
							</tr>
							<tr>
								<td colSpan="6">
									<button className="btn btn-danger" onClick={deleteHandlerAll}>Empty Cart</button>
									<button className="btn btn-warning mx-3" onClick={checkout}>Cash</button>
									<Stripe amount={total * 100} cartItems={cartItems} setCartItems={setCartItems} />
								</td>
							</tr>
						</tbody>
					</table>
				
				:	<h4 className="mt-5">Booking is Empty</h4> }
			</div>
			</div>
	)
}

export default Cart